import type { FaireProductEntity } from "../../entity_types/product";

export const p_mdg65zeq7t: FaireProductEntity = {
  token: "p_mdg65zeq7t",
  type: "product",
  name: "Detoxifier Shampoo Bar - clarifying for all hair types (blonde, gray & buildup)",
  brandToken: "b_55d0t9jb",
  brandName: "NOTICE Hair Co.",
  imageUrl:
    "https://cdn.faire.com/fastly/a940f98cbf5739c914e3db2daade52bab7d0c036116f1aba54324ec6b5c4a685.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/2f6c3b17d1cff1afb177effa52937f36dcbc64994c7b632d5673a23e630f0078.jpeg",
    "https://cdn.faire.com/fastly/7cf72270e3b620d34f730441cf246cc52d052126c1e0569e3924fcb03d920317.jpeg",
  ],
  priceDollars: 10,
  description:
    "The cleansing power of activated charcoal works to gently remove build-up that can lead to brassiness for blonde and gray hair, or that “weighed-down” feeling, while nutrient-rich aloe vera, rejuvenates the hair improving elasticity and banishing breakage.\n\nScented with an intoxicating blend of refreshing citrus notes of bergamot and blood orange, tangled with deep earthy aromas of patchouli and cedar wood.\n\nClarifying treatment, for most hair types, use as required (use caution with vivid hair colors).\n\nBEST FOR: build-up, blonde & gray hair\n\nFEATURES:\nEssential oil scenting\nApproximately 50-75 washes (will vary)\nColor-safe, vegan & cruelty-free",
  tags: [],
  msrpDollars: 20,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:52:15.163Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
